// extracted by mini-css-extract-plugin
export default {"container":"I--z","productName":"J--z","price":"K--z","dimensions":"L--z"};